module.exports = __webpack_public_path__ + "media/images/svg/thumb-down-060c777e17d3d7ca22ebef3cb7231829.svg";